import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import * as Icon from "react-feather"

const ChangeCulture = () => {
  return (
    <>
    <div className="change-culture ptb-80 bg-f7fafd">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12">
            <div className="change-culture-content">
              <h3>Integration Experts</h3>
              <div className="section-title">
                <div className="bar"></div>
              </div>
              <p>
                From Docker to Infrastructure as Code, enterprises are
                continuously looking for ways to both enable developers, find
                efficiencies, and protect the organization and to manage the
                ongoing balancing act between the needs of the individual vs
                their team vs the wider organization
              </p>
              <h6>Highlights:</h6>
              <ul>
              <li>
                {" "}
                Discovery: Review domain, processes, and systems to build a
                shared understanding (bottom up and top down) to create a
                prioritized backlog
              </li>
              <li>
                {" "}
                Implement: Teams iterate while investing in areas of reuse,
                coverage-focused data sets, test generation and execution, and
                relevant measures
              </li>
              <li>
                {" "}
                Accelerate: Championing cross domain, reusable components and
                expanding strategic automation to encourage change and adoption
              </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="about-image">
              <StaticImage
                src="../../assets/images/services/case-study/integration-experts.png"
                alt="Change your culture"
              />
            </div>
          </div>
    
          </div>
      
    </div>
    </div>
    <div className="change-culture1 ptb-80 bg-003c64">
      <div className="container">
    
          <div className="row align-items-center pt-80">
          <div className="col-lg-6 col-md-12">
            <div className="about-image" style={{paddingRight:"10px"}}>
              <StaticImage
                src="../../assets/images/services/case-study/day-in-life.png"
                alt="Change your culture"
              />
            </div>
            </div>
          <div className="col-lg-6 col-md-12">
            <div className="day-in-life">
              <h3>Day in the Life of a Software Engineer</h3>
              <div className="section-title">
                <div className="bar"></div>
                <ul>
                  <li>
                    Have a hypothesis (migrating to AWS will increase team
                    velocity)
                  </li>
                  <li>
                    Clarify features (seeing 10x growth, reduce cost, easily
                    scale, regional)
                  </li>
                  <li>
                    Figure out how to test this hypothesis (decouple state and
                    compute)
                  </li>
                  <li>
                    Build and experiment (network security, IAM policy
                    management, etc.){" "}
                  </li>
                  <li>
                    Measure and validate (unit test, integration tests,
                    load-test, slowest parts, data correctness, game days){" "}
                  </li>
                  <li>
                    Release{" "}
                  </li>
                  </ul>
                  {/* <img src={dayinlife} /> */}
              </div>
            </div>
          </div>
      
      </div>
    </div>
    </div>
    </>
  )
}

export default ChangeCulture
